(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["champion-back-to-top"] && !Shopify.designMode) return;
  try {
    const control = document.querySelector('.ct-back-top');
if (control) {
  control.hidden = false;
  control.querySelector('button').addEventListener('click', function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top:0,left:0,behavior:reduceMotion ? 'instant' : 'smooth'});
    const topTarget = document.querySelector('.skip-to-content');
    if (topTarget) topTarget.focus({preventScroll:true});
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["champion-plate-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('champion-plate-calculator')) return;
  const bounds = [25, 50, 100, 150, 200, 250, 288];
  class ChampionPlateCalculator extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || this.ready) return;
      this.ready = true;
      this.fields = [...this.querySelectorAll('[data-dimension]')];
      this.tiers = JSON.parse(this.querySelector('[data-plate-tiers]').textContent);
      this.status = this.querySelector('[data-status]');
      this.defaultStatus = this.status.textContent;
      this.abort = new AbortController();
      this.form.classList.add('ct-plate-calculator-active');
      this.addEventListener('input', () => { this.update(); }, {signal:this.abort.signal});
      this.form.addEventListener('submit', event => this.guard(event), {capture:true, signal:this.abort.signal});
      document.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button,input[type="submit"],a.pplr-btn,.pplr-btn');
        if (!button) return;
        const isOwnAdd = button.closest('form') === this.form && (button.matches('[name="add"], [type="submit"]') || button.closest('buy-button'));
        const isPersonalizer = !this.dataset.formId.includes('quick-buy') && button.matches('.pplr-btn,.pplr_add_to_cart,.pplr_atc_btn,#pplr-add-to-cart');
        if (isOwnAdd || isPersonalizer) this.guard(event);
      }, {capture:true, signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.syncPlateSize());
      this.observer.observe(document.body, {childList:true, subtree:true});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
    measure() {
      const raw = this.fields.map(field => field.value.trim());
      if (raw.some(value => !value)) return {error:this.dataset.empty};
      const [width,length] = raw.map(Number);
      if (![width,length].every(value => Number.isFinite(value) && value > 0)) return {error:this.dataset.invalid};
      if (Math.min(width,length) > 12 || Math.max(width,length) > 24) return {error:this.dataset.oversize};
      const area = width * length;
      const index = bounds.findIndex(bound => area <= bound + 1e-9);
      const title = index === 0 ? 'Up to 25 Square Inches' : `Over ${bounds[index - 1]} to ${bounds[index]} Square Inches`;
      const tier = this.tiers.find(item => item.title === title);
      if (!tier?.available) return {error:this.dataset.failed};
      return {width,length,area,tier};
    }
    update() {
      const result = this.measure();
      this.result = result;
      this.toggleAttribute('data-error', Boolean(result.error && this.fields.some(field => field.value)));
      this.fields.forEach(field => field.setCustomValidity(result.error || ''));
      this.querySelector('[data-area]').textContent = result.error ? '' : `${Number(result.area.toFixed(8))} ${this.dataset.unit}`;
      this.querySelector('[data-area-property]').value = result.error ? '' : String(Number(result.area.toFixed(8)));
      this.querySelector('[data-price]').textContent = result.error ? this.dataset.empty : result.tier.price;
      this.status.textContent = result.error || this.defaultStatus;
      if (!result.error) {
        this.syncPlateSize();
        this.selectTier();
      }
    }
    async selectTier() {
      if (this.busy) return;
      this.busy = true;
      try {
        await customElements.whenDefined('variant-picker');
        while (this.isConnected) {
          const result = this.measure();
          if (result.error) break;
          const current = this.form.querySelector('[name="id"]');
          if (String(current?.value) === String(result.tier.id)) break;
          const picker = this.form.querySelector('variant-picker');
          const radios = [...this.form.querySelectorAll('variant-picker input[data-option-position="1"]')];
          const radio = radios.find(input => this.form.querySelector(`label[for="${CSS.escape(input.id)}"]`)?.textContent.trim() === result.tier.option);
          const select = this.form.querySelector('variant-picker select[data-option-position="1"]');
          const option = select && [...select.options].find(item => item.textContent.trim() === result.tier.option);
          const optionValue = radio?.value || option?.value;
          if (!picker?.selectCombination || !optionValue) throw new Error('Variant selection unavailable');
          this.status.textContent = this.dataset.loading;
          await picker.selectCombination({optionValues:[optionValue],productChange:false});
          if (String(this.form.querySelector('[name="id"]')?.value) !== String(result.tier.id)) throw new Error('Variant did not match');
        }
        this.status.textContent = this.measure().error || this.defaultStatus;
      } catch (error) {
        this.status.textContent = this.dataset.failed;
        this.setAttribute('data-error','');
      } finally {
        this.busy = false;
        this.syncPlateSize();
      }
    }
    syncPlateSize() {
      const result = this.result;
      if (!result || result.error || this.syncing) return;
      this.syncing = true;
      try {
        const value = `${result.width}\u2033 x ${result.length}\u2033`;
        document.querySelectorAll('input[name="properties[Plate Size]"],textarea[name="properties[Plate Size]"]').forEach(input => {
          if (input.value !== value) {
            input.value = value;
            input.dispatchEvent(new Event('input',{bubbles:true}));
            input.dispatchEvent(new Event('change',{bubbles:true}));
          }
          input.readOnly = true;
        });
      } finally { this.syncing = false; }
    }
    guard(event) {
      const result = this.measure();
      const matches = !result.error && String(this.form.querySelector('[name="id"]')?.value) === String(result.tier.id);
      if (result.error || this.busy || !matches) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.status.textContent = result.error || this.dataset.loading;
        this.setAttribute('data-error','');
        this.scrollIntoView({block:'center',behavior:'smooth'});
        if (result.error) { this.fields.find(field => !field.value)?.focus(); this.fields[0].reportValidity(); }
        else this.selectTier();
      } else this.syncPlateSize();
    }
  }
  customElements.define('champion-plate-calculator',ChampionPlateCalculator);
})();
  } catch(e) { console.error(e); }
})();

})();
